// extracted by mini-css-extract-plugin
export var contentBody = "_4c-9";
export var headerImage = "_4c-2";
export var imageButton = "_4c-7";
export var imageButtonIcon = "_4c-8";
export var imageHeader = "_4c-4";
export var imageHeaderText = "_4c-5";
export var imageOverlay = "_4c-3";
export var imageTitle = "_4c-6";
export var imageWrapper = "_4c-1";
export var taskList = "_4c-a";
export var widget = "_4c-0";